import type { Vec2 } from './protocol.ts';

/** Shared architectural coordinates. The complete radius-3.1 birthday circle stays clear. */
export const ROOM_BOUNDS = { minX: -6.45, maxX: 6.45, minZ: -4.75, maxZ: 4.75 } as const;
export const CELEBRATION_CENTER: Vec2 = { x: 0, z: 0 };
export const ROOM_OBSTACLES: { x: number; z: number; w: number; d: number }[] = [
  { x: -4.66, z: -4.18, w: 3.45, d: 1.13 }, // kitchen
  { x: -5.23, z: -0.23, w: 2.48, d: 1.48 }, // sofa
  { x: -4.75, z: 2.04, w: 0.82, d: 0.82 }, // side table
  { x: 0, z: -4.12, w: 1.85, d: 1.09 }, // everyday cake pedestal
  { x: 4.44, z: -3.98, w: 3.23, d: 1.31 }, // gifts and piggy table
  { x: 5.3, z: 0.32, w: 1.82, d: 0.63 }, // physical wish board
  { x: -5.68, z: 3.88, w: 0.9, d: 0.9 }, // plants
  { x: 5.7, z: 3.8, w: 0.9, d: 0.9 },
  { x: 3.95, z: 3.95, w: 1.94, d: 0.44 }, // wooden toy train
  { x: -3.9, z: 3.95, w: 0.81, d: 0.44 }, // play blocks
  { x: -5.35, z: 1.33, w: 0.29, d: 0.29 }, // balloon weights
  { x: 5.52, z: -0.85, w: 0.29, d: 0.29 },
];

/** Walkable destinations just in front of the objects, never inside their colliders. */
export const INTEREST_POINTS: Vec2[] = [
  { x: -4.4, z: 0.97 }, { x: -4.01, z: 2.07 }, { x: -3.85, z: -2.92 },
  { x: 0, z: -2.95 }, { x: 3.6, z: -2.86 }, { x: 4.87, z: -2.86 },
  { x: 4.1, z: 0.79 }, { x: 0, z: 2.8 }, { x: -2.75, z: 2.82 },
  { x: 2.77, z: 2.78 }, { x: -1.95, z: -1.84 }, { x: 1.9, z: -1.75 },
];
